import type { ComponentProps } from 'react';
import type { Tag } from 'sonata-react-components';

type TagProps = ComponentProps<typeof Tag>;

const GROUP_COLOR_BACKGROUND_TINTS: Record<string, string> = {
  'var(--color-charts-li-blue-500)': '#E9F5FF',
  'var(--color-charts-li-green-400)': '#F0FFE3',
  'var(--color-charts-li-green-600)': '#E8FFFE',
  'var(--color-charts-li-orange-500)': '#FFF7E8',
  'var(--color-charts-li-orange-600)': '#FFF0ED',
  'var(--color-charts-li-pink-400)': '#FFEEF3',
  'var(--color-charts-li-pink-600)': '#FFF5FB',
  'var(--color-charts-li-purple-500)': '#F3EAFF'
};

// Groups created before the color picker (legacy defaults, CSV imports, auto-generated
// attribution zones) carry arbitrary hex colors outside GROUP_COLOR_BACKGROUND_TINTS.
// For those, compute an approximate pastel tint instead of falling back to a solid fill.
const getGroupTagBackground = (color: string): string =>
  GROUP_COLOR_BACKGROUND_TINTS[color] ?? `color-mix(in srgb, ${color} 12%, white)`;

const MULTI_GROUP_ICON_COLOR = 'var(--color-status-pending-600, #2C45D1)';

const MULTI_GROUP_COLORS = {
  background: 'var(--color-status-pending-400, #DDE2FF)',
  border: MULTI_GROUP_ICON_COLOR
};

/** Tag colors and icon for an item's groups: the group color for one group, the "multi-group" style otherwise. */
export function getGroupTagStyle(groups: { color?: string }[]): Pick<TagProps, 'customColors' | 'icon'> {
  const singleColor = groups.length === 1 ? groups[0].color : undefined;
  if (singleColor) {
    return {
      customColors: { background: getGroupTagBackground(singleColor), border: singleColor },
      icon: { color: singleColor, webFont: 'fa-solid fa-circles-overlap' }
    };
  }
  return {
    customColors: MULTI_GROUP_COLORS,
    icon: { color: MULTI_GROUP_ICON_COLOR, webFont: 'fa-solid fa-circles-overlap-3' }
  };
}
